import React from 'react'
import Dialog from 'material-ui/Dialog';

class SettingsComponent extends React.Component {
    render() {
        return (<Dialog
                onRequestClose={this.props.onRequestClose}
                autoScrollBodyContent={this.props.autoScrollBodyContent}
                open={this.props.open}
                children={this.props.children}
            />
        )
    }
}

export default SettingsComponent;


// WEBPACK FOOTER //
// ./src/layout/dialogs/SettingsComponent.js